import React, { createContext, useContext, type ReactNode } from 'react';

import type { Config } from 'app/config';
import createAuthService from 'app/services/auth';
import createPasswordService from 'app/services/password';
import createCognitoService from 'app/services/cognito';
import createHyrox365Service from 'app/services/hyrox365';
import { createHyroxMirror } from 'app/utils/hyrox-mirror';

const createServices = (config: Config) => ({
  auth: createAuthService({
    clientId: config.REACT_APP_AUTH_CLIENT_ID,
    clientSecret: config.REACT_APP_AUTH_CLIENT_SECRET,
    url: config.REACT_APP_AUTH_URL,
    oneFiitAuthUrl: config.REACT_APP_ONE_FIIT_AUTH_URL,
    oneFiitClientId: config.REACT_APP_CLIENT_ID_FOR_ONE_FIIT,
    oneFiitAuthCodeUrl: config.REACT_APP_ONE_FIIT_AUTH_CODE_URL,
    authCallbackRedirectUrl: config.REACT_APP_AUTH_CALLBACK_REDIRECT_URL,
  }),
  password: createPasswordService({
    url: config.REACT_APP_PASSWORD_URL,
  }),
  cognito: createCognitoService({
    url: config.REACT_APP_COGNITO_EXCHANGE_URL,
    oneFiitAuthUrl: config.REACT_APP_ONE_FIIT_AUTH_URL,
    clientId: config.REACT_APP_CLIENT_ID_FOR_ONE_FIIT,
  }),
  hyrox365: createHyrox365Service({
    bffUrl: config.REACT_APP_HYROX_BFF_URL,
  }),
  // null unless REACT_APP_HYROX_MIRROR_BASE_URL is set (sub-plan S, JS-9603)
  hyroxMirror: createHyroxMirror(config),
});

const context = createContext({} as ReturnType<typeof createServices>);
const { Provider } = context;

export const ServicesProvider = ({ children, config }: { children: ReactNode; config: Config }) => (
  <Provider value={createServices(config)}>{children}</Provider>
);

export default () => useContext(context);
